module.exports = __webpack_public_path__ + "9fd64b8a7b90cbff298e147b0930078c.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/rockers.jpg
 ** module id = 470
 ** module chunks = 0
 **/